import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataEntityEditorBaseComponent } from '../../data-entity-editor-base/data-entity-editor-base.component';
import { ContractorService, DataService, WorkflowContextService } from 'src/app/services';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectContractorDataEntity } from 'src/app/models/data-entities/select-contractor-data-entity';

@Component({
    selector: 'wm-select-contractor-data-entity-editor',
    templateUrl: './select-contractor-data-entity-editor.component.html',
    styleUrl: './select-contractor-data-entity-editor.component.css',
    standalone: false
})
export class SelectContractorDataEntityEditorComponent extends DataEntityEditorBaseComponent implements OnInit, OnDestroy {
  availableContractorTypes: { id: string, name: string }[];
  subFormCode = '';
  subForm: UntypedFormGroup;

  dataEntity: SelectContractorDataEntity;

  constructor(private _dataSvc: DataService, private _contractorSvc: ContractorService, private _context: WorkflowContextService) {
    super();
  }
  ngOnDestroy(): void {
    if (this.form) {
      this.form.removeControl(this.subFormCode)
    }
  }

  ngOnInit(): void {
    this.subFormCode = this.dataEntity.templateCode + '-form';

    if (this.form && this.dataEntity) {
      const frm = new UntypedFormGroup({
        contractorTypes: new UntypedFormControl(null, this._context.client ? Validators.required : Validators.nullValidator),
        allowNotListedOption: new UntypedFormControl(this.dataEntity.allowNotListedOption, Validators.nullValidator),
        allowRegisterRenewalOption: new UntypedFormControl(this.dataEntity.allowRegisterRenewOption, Validators.required)
      });

      this.subForm = frm;
      this.form.addControl(this.subFormCode, this.subForm);
    }

    if (this.targetClientId || this._context.client) {
      this._dataSvc.getContractorTypes(this.targetClientId || this._context.client.id).subscribe(results => {
        this.availableContractorTypes = results.map(r => { return { id: r.id, name: r.name } });
      });
    }
    else {
      this.availableContractorTypes = [];
    }

    this.setSelectedCOntractorValue();
  }

  setSelectedCOntractorValue() {
    if (this.subForm) {
      this.subForm.controls['contractorTypes'].setValue(this.dataEntity?.contractorTypeIds?.join(',') || '');
    }
  }
  isSelected(id: string) {
    if (this.dataEntity && this.dataEntity.contractorTypeIds) {
      return this.dataEntity.contractorTypeIds.includes(id);
    }
  }
  selectContractorType(checked: boolean, id: string) {
    if (checked) {
      if (this.dataEntity.contractorTypeIds && !this.dataEntity.contractorTypeIds.includes(id)) {
        this.dataEntity.contractorTypeIds.push(id);
      }
    }
    else {
      if (this.dataEntity.contractorTypeIds && this.dataEntity.contractorTypeIds.includes(id)) {
        const idx = this.dataEntity.contractorTypeIds.indexOf(id);
        if (idx > -1) {
          this.dataEntity.contractorTypeIds.splice(idx, 1);
        }
      }
    }

    this.setSelectedCOntractorValue();
  }
}
